"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: indexRef,
    isVisible: indexVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.15
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="1607" id="hero" className="relative min-h-screen w-full bg-background text-foreground pt-32 pb-24 border-t border-b border-border overflow-hidden">
      <div className="mx-auto max-w-[1440px] px-6 md:px-16 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-8 min-h-[calc(100vh-14rem)]">
          {}
          <div ref={imageRef} className={`lg:col-span-7 flex flex-col transition-all duration-700 ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            {}
            <div className="relative w-full mb-4">
              <div className={`h-px bg-border transition-all duration-500 ease-out ${imageVisible ? "w-full" : "w-0"}`} />
              <span className="absolute right-0 top-1/2 -translate-y-1/2 w-1.5 h-1.5 bg-[var(--chart-2)]" />
            </div>

            {}

            {}
            <div className="relative flex-1 overflow-hidden rounded-lg shadow-lg">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692402/img/pulmonary_care_facility.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692402/img/pulmonary_care_facility.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692402/img/pulmonary_care_facility.png-wvc-sizes" alt="Modern pulmonary care facility with advanced diagnostic equipment and natural lighting" loading="lazy" decoding="async" className={`h-full w-full object-cover min-h-[420px] md:min-h-[560px] lg:min-h-[640px] transition-opacity duration-700 ease-out ${imageVisible ? "opacity-100" : "opacity-0"}`} />
            </div>
          </div>

          {}
          <div className="lg:col-span-5 flex flex-col justify-center lg:pl-8">
            {}
            <div ref={indexRef} className={`mb-16 md:mb-20 transition-all duration-700 ease-out ${indexVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <span className="font-mono text-[0.6875rem] md:text-[0.8125rem] tracking-[0.18em] uppercase text-foreground">
                REFERRING PROVIDERS
              </span>
            </div>

            {}
            <h1 ref={headlineRef} className={`font-default font-semibold text-foreground transition-all duration-700 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            fontSize: "clamp(3.25rem, 7.2vw, 7.5rem)",
            letterSpacing: "-0.03em",
            lineHeight: "0.95",
            transitionDelay: "80ms"
          }}>
              For Referring Providers
            </h1>

            {}
            <p ref={bodyRef} className={`mt-14 max-w-md font-default font-normal text-muted-foreground transition-all duration-700 ease-out ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            fontSize: "clamp(1.0625rem, 1.15vw, 1.25rem)",
            letterSpacing: "-0.005em",
            lineHeight: "1.55",
            transitionDelay: "160ms"
          }}>
              Chaudhry Pulmonary Associates works with primary care physicians, specialists, discharge planners, and clinical offices to support adult patients with pulmonary and sleep-related concerns.
            </p>

            {}
            <div ref={ctaRef} className={`mt-12 flex flex-col items-start gap-6 transition-all duration-700 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: "240ms"
          }}>
              <Button className="group relative bg-primary px-9 py-5 h-auto text-primary-foreground hover:bg-primary/90 rounded-lg shadow-md transition-all duration-[220ms] font-default font-medium text-base tracking-[0.04em]">
                <span className="relative inline-block">
                  Fax Referral: (412) 533-5622
                  <span className="absolute left-0 -bottom-1 h-px w-0 bg-accent transition-all duration-[320ms] ease-out group-hover:w-full" />
                </span>
              </Button>

              <Link to="tel:+14126729240" className="group font-default text-foreground font-medium text-base" style={{
              letterSpacing: "0"
            }}>
                <span className="inline-block border-b border-border pb-1 transition-all duration-[220ms] ease-out group-hover:border-primary" style={{
                textUnderlineOffset: "6px"
              }}>
                  Call Office: (412) 672-9240
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}